import GAHTMLElement from '../ga/GAHTMLElement';

export default class ScrollView {
    static inView() {
        ScrollView.inViewWithoutScroll();
    }

    static indexPageScrollHandler() {
        document.addEventListener('scroll', ScrollView.inView);
        ScrollView.inViewWithoutScroll();
    }

    static inViewWithoutScroll() {
        /**
         * Главный баннер для десктопа
         */
        const normalBlocks = GAHTMLElement.getPromosInMainPage();

        normalBlocks.forEach(ScrollView.setViewedElement);

        const items = GAHTMLElement.getProductsInMainPage();

        items.forEach(ScrollView.setViewedElement);
    }

    private static setViewedElement(element: HTMLElement) {
        if (ScrollView.controlView(element)) {
            if (element.dataset.gaViewed !== 'true') {
                element.dataset.gaViewed = 'true';
            }
        }
    }

    static controlView(element: HTMLElement) {
        let result = false;
        // Координаты дива
        const elementPosition = element.getBoundingClientRect();
        // Отступ сверху
        const elTop = elementPosition.top;
        // Отступ слева
        const elLeft = elementPosition.left;
        // Ширина
        const elWidth = element.offsetWidth;
        // Высота
        const elHeight = element.offsetHeight;

        // Проскроллено сверху
        const topScroll = document.documentElement.scrollTop;
        // Проскроллено слева
        const leftScroll = document.documentElement.scrollLeft;
        // Ширина видимой страницы
        const screenWidth = window.innerWidth;
        // Высота видимой страницы
        const screenHeight = window.innerHeight;

        // Координаты углов видимой области
        const seeX1 = leftScroll;
        const seeX2 = screenWidth + leftScroll;
        const seeY1 = topScroll;
        const seeY2 = screenHeight + topScroll;

        // Координаты углов искомого элемента
        const elX1 = elLeft;
        const elX2 = elLeft + elWidth;
        const elY1 = elTop;
        const elY2 = elTop + elHeight;

        if (elX1 >= seeX1 && elX2 <= seeX2 && elY1 >= seeY1 && elY2 <= seeY2) {
            result = true;
        }

        return result;
    }
}
